import { styled, SvgIcon, SvgIconProps } from '@mui/material';

const CircleOutline = ({ size, ...rest }: SvgIconProps & { size: number }) => {
  const viewBox = `0 0 ${size} ${size}`;
  const radius = size / 2 - 1.5;
  return (
    <SvgIcon viewBox={viewBox} sx={{ width: size, height: size }} {...rest}>
      <circle cx="50%" cy="50%" r={radius} fill="none" stroke="var(--mds-Radio-ringColor, currentColor)" />
    </SvgIcon>
  );
};

const Dot = ({ size, checked, ...rest }: SvgIconProps & { size: number; checked: boolean }) => (
  <SvgIcon viewBox={`0 0 ${size} ${size}`} sx={{ width: size, height: size }} {...rest}>
    <circle cx="50%" cy="50%" r="4.5" fill="currentColor" />
  </SvgIcon>
);

const RadioButtonIconRoot = styled('span')({
  position: 'relative',
  display: 'flex',
});

const RadioButtonIconBackground = styled(CircleOutline)({
  // Scale applied to prevent dot misalignment in Safari
  transform: 'scale(1)',
});

const RadioButtonIconDot = styled(Dot)(({ theme }) => ({
  left: 0,
  position: 'absolute',
  transform: 'scale(0)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: { checked: true },
      style: {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest,
        }),
      },
    },
  ],
}));

export function RadioButtonIcon({
  checked = false,
  fontSize = 'medium',
}: {
  checked?: boolean;
  fontSize?: 'small' | 'medium';
}) {
  const size = fontSize === 'medium' ? 21 : 17;
  return (
    <RadioButtonIconRoot sx={{ width: size, height: size }}>
      <RadioButtonIconBackground size={size} />
      <RadioButtonIconDot size={size} checked={checked} />
    </RadioButtonIconRoot>
  );
}
